<template>    
    <div class="accessIndex__locations">
        <!-- <div class="accessIndex__reload--container"
            @click="previousSelection()">
            <i class="material-icons" style="color: #009CDE">keyboard_backspace</i>
        </div> -->
        <v-flex xs12 row style="margin-bottom:15px">
            <p class="accessIndex__text--title" >Lugar de entrenamiento</p>
        </v-flex>        
        <div
          class="accessIndex__locations--item_access"
          v-for="(sublocation, index) in sublocations" :key="index"
          @click="$emit('selected',{name: sublocation.name, id: sublocation.id})">
            <div class="accessIndex__locations--item_info">
                <div class="accessIndex__text--small_left">
                    <p>{{sublocation.name}}</p>
                </div>
            </div>
        </div>
      </div>
</template>

<script>
    export default {
        data() {
            return {
                sublocations:[],                                            
            }
        },
        props: ["location"],
        methods: {    
            requestSublocation(){             
                var vm = this;
                try{
                    vm.$http.get('app/sublocations', {
                        headers: {
                            "X-Device-ID" : this.getDeviceId(),
                            "Authorization" : 'Bearer ' + this.getUserToken()
                        },
                        params:{ location_id: vm.location[0].id }
                    }).then(function(response){                    
                        vm.sublocations=response.body;
                        if(response.body.meta != undefined && response.body.meta != null){
                            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                                this.checkToken(response.body.meta.authentication_token)
                            }
                        }
                    }, function(response){
                        if(response.body.meta != undefined && response.body.meta != null){
                            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                                this.checkToken(response.body.meta.authentication_token)
                            }
                        }
                        console.log("Respuesta error de reservas");
                        if (response.status==401) { 
                            // alert(response.body.errors[0].details, "Un momento...");
                            this.updateAlertMessage("Tienes una sesión abierta en otro dispositivo.", "Un momento...");
                            this.updateIsInAlert(true)
                        }else{
                            this.updateAlertMessage(response.body.errors[0].details);
                            this.updateIsInAlert(true)
                        }
                    });
                }catch(e){
                    console.log("Fallo reservas home");
                    alert(e.message);
                }
                vm.is_changed = false;
            }            
        },
        mounted(){
            var vm = this;                      
            this.requestSublocation();
        },
        
    }
</script>



// WEBPACK FOOTER //
// src/components/views/bookings/SublocationSelect.vue